import { compareValues, isRegexMatch } from "@sscs/utils";
export const initFilter = {
    classification: "ALL",
    searchRegex: "",
    tag: null,
};
export const initSort = {
    property: "classification_result",
    reverse: true,
};
export const filterNetworking = (networking, filter) => {
    const hasClassificationFilter = filter.classification !== initFilter.classification;
    const hasValueFilter = filter.searchRegex !== initFilter.searchRegex;
    const hasTagFilter = filter.tag !== initFilter.tag;
    if (!hasClassificationFilter && !hasValueFilter && !hasTagFilter) {
        return networking;
    }
    return networking.filter((uri) => {
        if (hasClassificationFilter &&
            uri.classification.classification !== filter.classification) {
            return false;
        }
        if (hasTagFilter && filter.tag && !uri.tags.includes(filter.tag)) {
            return false;
        }
        if (hasValueFilter && !isRegexMatch(uri.value, filter.searchRegex)) {
            return false;
        }
        return true;
    });
};
export const specialCasesForSorting = {
    classification_result: (first, second, reverse) => {
        return compareValues(first.classification.result, second.classification.result, reverse);
    },
};
//# sourceMappingURL=utils.js.map